"use client";

import { c as _c } from "react/compiler-runtime";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { type HTMLMotionProps, motion } from "motion/react";
import * as React from "react";
import { cn } from "@/lib/utils";
type CheckboxProps = React.ComponentProps<typeof CheckboxPrimitive.Root> & HTMLMotionProps<"button"> & {
  onCheckedChange?: (checked: boolean) => void;
};
function Checkbox(t0) {
  const $ = _c(25);
  let className;
  let onCheckedChange;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      onCheckedChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onCheckedChange;
    $[3] = props;
  } else {
    className = $[1];
    onCheckedChange = $[2];
    props = $[3];
  }
  const [isChecked, setIsChecked] = React.useState(props?.checked ?? props?.defaultChecked ?? false);
  let t1;
  if ($[4] !== props) {
    t1 = () => {
      if (props?.checked !== undefined) {
        setIsChecked(props.checked);
      }
    };
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = props?.checked;
  let t3;
  if ($[6] !== t2) {
    t3 = [t2];
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  React.useEffect(t1, t3);
  let t4;
  if ($[8] !== onCheckedChange) {
    t4 = checked => {
      const booleanChecked = checked === true;
      setIsChecked(booleanChecked);
      if (onCheckedChange) {
        onCheckedChange(booleanChecked);
      }
    };
    $[8] = onCheckedChange;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleCheckedChange = t4;
  let t5;
  if ($[10] !== className) {
    t5 = cn("peer size-5 flex items-center justify-center shrink-0 rounded-sm bg-input transition-colors duration-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", className);
    $[10] = className;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      scale: 0.95
    };
    t7 = {
      scale: 1.05
    };
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  const t8 = isChecked ? "checked" : "unchecked";
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      pathLength: 1,
      opacity: 1,
      transition: {
        duration: 0.2,
        delay: 0.2
      }
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <motion.path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" variants={{
      checked: t9,
      unchecked: {
        pathLength: 0,
        opacity: 0,
        transition: {
          duration: 0.2
        }
      }
    }} />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t8) {
    t11 = <CheckboxPrimitive.Indicator forceMount={true} asChild={true}><motion.svg data-slot="checkbox-indicator" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="3.5" stroke="currentColor" className="size-3.5" initial="unchecked" animate={t8} role="img" aria-label="Checkbox indicator">{t10}</motion.svg></CheckboxPrimitive.Indicator>;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t5) {
    t12 = <motion.button data-slot="checkbox" className={t5} whileTap={t6} whileHover={t7}>{t11}</motion.button>;
    $[18] = t11;
    $[19] = t5;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== handleCheckedChange || $[22] !== props || $[23] !== t12) {
    t13 = <CheckboxPrimitive.Root {...props} onCheckedChange={handleCheckedChange} asChild={true}>{t12}</CheckboxPrimitive.Root>;
    $[21] = handleCheckedChange;
    $[22] = props;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}
export { Checkbox, type CheckboxProps };